import * as Sentry from '@sentry/browser'

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
function isError(err: Error | unknown): err is Error {
  return err instanceof Error
}

window.onDomLoad(function () {
  try {
    if ($('body').data('sentry-enabled')) {
      const dsn = ($('body').data('sentry-dsn') as string) || ''
      const release = ($('body').data('release') as string) || ''
      const responseErrorText =
        /object captured as exception with keys: body, ok, status, statusText/i

      Sentry.init({
        dsn,
        release,
        denyUrls: [/js\.intercomcdn\.com/i],
        ignoreErrors: [responseErrorText, /network error/i],

        beforeSend: function (event, hint) {
          const originalException = hint?.originalException
          const originalMessage = isError(originalException)
            ? originalException.message
            : ''

          // Force group all file storing errors together
          if (originalMessage.toLowerCase().includes('error storing')) {
            event.fingerprint = ['file-storing-error']
          }

          return event
        },
      })

      window.Sentry = Sentry
    }
  } catch (err) {
    if (isError(err)) {
      console.error(err?.message)
    }
  }
})
